// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/organization.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ID, Timezone } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/organization.proto.
 */
export const file_core_v1_organization: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_types]);

/**
 * Organization represents a company or entity in the system
 *
 * @generated from message core.v1.Organization
 */
export type Organization = Message<"core.v1.Organization"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string idp_id = 2;
   */
  idpId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string domain = 4;
   */
  domain: string;

  /**
   * @generated from field: google.protobuf.Timestamp onboarded_at = 5;
   */
  onboardedAt?: Timestamp;

  /**
   * @generated from field: types.Timezone timezone = 6;
   */
  timezone?: Timezone;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message core.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 0);

/**
 * @generated from message core.v1.CreateOrganizationRequest
 */
export type CreateOrganizationRequest = Message<"core.v1.CreateOrganizationRequest"> & {
  /**
   * @generated from field: core.v1.CreateOrganizationInput input = 1;
   */
  input?: CreateOrganizationInput;
};

/**
 * Describes the message core.v1.CreateOrganizationRequest.
 * Use `create(CreateOrganizationRequestSchema)` to create a new message.
 */
export const CreateOrganizationRequestSchema: GenMessage<CreateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 1);

/**
 * @generated from message core.v1.CreateOrganizationInput
 */
export type CreateOrganizationInput = Message<"core.v1.CreateOrganizationInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;

  /**
   * @generated from field: types.Timezone timezone = 4;
   */
  timezone?: Timezone;

  /**
   * @generated from field: google.protobuf.Timestamp onboarded_at = 5;
   */
  onboardedAt?: Timestamp;

  /**
   * @generated from field: string idp_id = 6;
   */
  idpId: string;
};

/**
 * Describes the message core.v1.CreateOrganizationInput.
 * Use `create(CreateOrganizationInputSchema)` to create a new message.
 */
export const CreateOrganizationInputSchema: GenMessage<CreateOrganizationInput> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 2);

/**
 * @generated from message core.v1.UpdateOrganizationRequest
 */
export type UpdateOrganizationRequest = Message<"core.v1.UpdateOrganizationRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;

  /**
   * @generated from field: types.Timezone timezone = 4;
   */
  timezone?: Timezone;

  /**
   * @generated from field: google.protobuf.Timestamp onboarded_at = 5;
   */
  onboardedAt?: Timestamp;

  /**
   * @generated from field: string idp_id = 6;
   */
  idpId: string;
};

/**
 * Describes the message core.v1.UpdateOrganizationRequest.
 * Use `create(UpdateOrganizationRequestSchema)` to create a new message.
 */
export const UpdateOrganizationRequestSchema: GenMessage<UpdateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 3);

/**
 * @generated from message core.v1.GetOrganizationRequest
 */
export type GetOrganizationRequest = Message<"core.v1.GetOrganizationRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.GetOrganizationRequest.
 * Use `create(GetOrganizationRequestSchema)` to create a new message.
 */
export const GetOrganizationRequestSchema: GenMessage<GetOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 4);

/**
 * @generated from message core.v1.GetOrganizationByNameRequest
 */
export type GetOrganizationByNameRequest = Message<"core.v1.GetOrganizationByNameRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message core.v1.GetOrganizationByNameRequest.
 * Use `create(GetOrganizationByNameRequestSchema)` to create a new message.
 */
export const GetOrganizationByNameRequestSchema: GenMessage<GetOrganizationByNameRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 5);

/**
 * @generated from message core.v1.GetOrganizationByDomainRequest
 */
export type GetOrganizationByDomainRequest = Message<"core.v1.GetOrganizationByDomainRequest"> & {
  /**
   * @generated from field: string domain = 1;
   */
  domain: string;
};

/**
 * Describes the message core.v1.GetOrganizationByDomainRequest.
 * Use `create(GetOrganizationByDomainRequestSchema)` to create a new message.
 */
export const GetOrganizationByDomainRequestSchema: GenMessage<GetOrganizationByDomainRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 6);

/**
 * @generated from message core.v1.GetOrganizationByIdpIDAndUserRequest
 */
export type GetOrganizationByIdpIDAndUserRequest = Message<"core.v1.GetOrganizationByIdpIDAndUserRequest"> & {
  /**
   * @generated from field: string idp_id = 1;
   */
  idpId: string;

  /**
   * @generated from field: types.ID user_id = 2;
   */
  userId?: ID;
};

/**
 * Describes the message core.v1.GetOrganizationByIdpIDAndUserRequest.
 * Use `create(GetOrganizationByIdpIDAndUserRequestSchema)` to create a new message.
 */
export const GetOrganizationByIdpIDAndUserRequestSchema: GenMessage<GetOrganizationByIdpIDAndUserRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 7);

/**
 * @generated from message core.v1.DeleteOrganizationRequest
 */
export type DeleteOrganizationRequest = Message<"core.v1.DeleteOrganizationRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.DeleteOrganizationRequest.
 * Use `create(DeleteOrganizationRequestSchema)` to create a new message.
 */
export const DeleteOrganizationRequestSchema: GenMessage<DeleteOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 8);

/**
 * @generated from message core.v1.GetOrganizationsRequest
 */
export type GetOrganizationsRequest = Message<"core.v1.GetOrganizationsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];
};

/**
 * Describes the message core.v1.GetOrganizationsRequest.
 * Use `create(GetOrganizationsRequestSchema)` to create a new message.
 */
export const GetOrganizationsRequestSchema: GenMessage<GetOrganizationsRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 9);

/**
 * @generated from message core.v1.GetOrganizationResponse
 */
export type GetOrganizationResponse = Message<"core.v1.GetOrganizationResponse"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.GetOrganizationResponse.
 * Use `create(GetOrganizationResponseSchema)` to create a new message.
 */
export const GetOrganizationResponseSchema: GenMessage<GetOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 10);

/**
 * @generated from message core.v1.GetOrganizationByNameResponse
 */
export type GetOrganizationByNameResponse = Message<"core.v1.GetOrganizationByNameResponse"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.GetOrganizationByNameResponse.
 * Use `create(GetOrganizationByNameResponseSchema)` to create a new message.
 */
export const GetOrganizationByNameResponseSchema: GenMessage<GetOrganizationByNameResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 11);

/**
 * @generated from message core.v1.GetOrganizationByDomainResponse
 */
export type GetOrganizationByDomainResponse = Message<"core.v1.GetOrganizationByDomainResponse"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.GetOrganizationByDomainResponse.
 * Use `create(GetOrganizationByDomainResponseSchema)` to create a new message.
 */
export const GetOrganizationByDomainResponseSchema: GenMessage<GetOrganizationByDomainResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 12);

/**
 * @generated from message core.v1.GetOrganizationByIdpIDAndUserResponse
 */
export type GetOrganizationByIdpIDAndUserResponse = Message<"core.v1.GetOrganizationByIdpIDAndUserResponse"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.GetOrganizationByIdpIDAndUserResponse.
 * Use `create(GetOrganizationByIdpIDAndUserResponseSchema)` to create a new message.
 */
export const GetOrganizationByIdpIDAndUserResponseSchema: GenMessage<GetOrganizationByIdpIDAndUserResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 13);

/**
 * @generated from message core.v1.GetOrganizationsResponse
 */
export type GetOrganizationsResponse = Message<"core.v1.GetOrganizationsResponse"> & {
  /**
   * @generated from field: repeated core.v1.Organization organizations = 1;
   */
  organizations: Organization[];
};

/**
 * Describes the message core.v1.GetOrganizationsResponse.
 * Use `create(GetOrganizationsResponseSchema)` to create a new message.
 */
export const GetOrganizationsResponseSchema: GenMessage<GetOrganizationsResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 14);

/**
 * @generated from message core.v1.CreateOrganizationResponse
 */
export type CreateOrganizationResponse = Message<"core.v1.CreateOrganizationResponse"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.CreateOrganizationResponse.
 * Use `create(CreateOrganizationResponseSchema)` to create a new message.
 */
export const CreateOrganizationResponseSchema: GenMessage<CreateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 15);

/**
 * @generated from message core.v1.UpdateOrganizationResponse
 */
export type UpdateOrganizationResponse = Message<"core.v1.UpdateOrganizationResponse"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.UpdateOrganizationResponse.
 * Use `create(UpdateOrganizationResponseSchema)` to create a new message.
 */
export const UpdateOrganizationResponseSchema: GenMessage<UpdateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 16);

/**
 * @generated from message core.v1.GrantOrganizationEntitlementRequest
 */
export type GrantOrganizationEntitlementRequest = Message<"core.v1.GrantOrganizationEntitlementRequest"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;

  /**
   * @generated from field: string entitlement = 2;
   */
  entitlement: string;
};

/**
 * Describes the message core.v1.GrantOrganizationEntitlementRequest.
 * Use `create(GrantOrganizationEntitlementRequestSchema)` to create a new message.
 */
export const GrantOrganizationEntitlementRequestSchema: GenMessage<GrantOrganizationEntitlementRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 17);

/**
 * @generated from message core.v1.RevokeOrganizationEntitlementRequest
 */
export type RevokeOrganizationEntitlementRequest = Message<"core.v1.RevokeOrganizationEntitlementRequest"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;

  /**
   * @generated from field: string entitlement = 2;
   */
  entitlement: string;
};

/**
 * Describes the message core.v1.RevokeOrganizationEntitlementRequest.
 * Use `create(RevokeOrganizationEntitlementRequestSchema)` to create a new message.
 */
export const RevokeOrganizationEntitlementRequestSchema: GenMessage<RevokeOrganizationEntitlementRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 18);

/**
 * @generated from message core.v1.GrantOrganizationEntitlementResponse
 */
export type GrantOrganizationEntitlementResponse = Message<"core.v1.GrantOrganizationEntitlementResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message core.v1.GrantOrganizationEntitlementResponse.
 * Use `create(GrantOrganizationEntitlementResponseSchema)` to create a new message.
 */
export const GrantOrganizationEntitlementResponseSchema: GenMessage<GrantOrganizationEntitlementResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 19);

/**
 * @generated from message core.v1.RevokeOrganizationEntitlementResponse
 */
export type RevokeOrganizationEntitlementResponse = Message<"core.v1.RevokeOrganizationEntitlementResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message core.v1.RevokeOrganizationEntitlementResponse.
 * Use `create(RevokeOrganizationEntitlementResponseSchema)` to create a new message.
 */
export const RevokeOrganizationEntitlementResponseSchema: GenMessage<RevokeOrganizationEntitlementResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 20);

/**
 * @generated from message core.v1.ResetOrganizationRequest
 */
export type ResetOrganizationRequest = Message<"core.v1.ResetOrganizationRequest"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.ResetOrganizationRequest.
 * Use `create(ResetOrganizationRequestSchema)` to create a new message.
 */
export const ResetOrganizationRequestSchema: GenMessage<ResetOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 21);

/**
 * @generated from message core.v1.ResetOrganizationResponse
 */
export type ResetOrganizationResponse = Message<"core.v1.ResetOrganizationResponse"> & {
  /**
   * @generated from field: types.ID new_organization_id = 1;
   */
  newOrganizationId?: ID;

  /**
   * @generated from field: types.ID new_facility_id = 2;
   */
  newFacilityId?: ID;

  /**
   * @generated from field: bool success = 3;
   */
  success: boolean;
};

/**
 * Describes the message core.v1.ResetOrganizationResponse.
 * Use `create(ResetOrganizationResponseSchema)` to create a new message.
 */
export const ResetOrganizationResponseSchema: GenMessage<ResetOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_organization, 22);

/**
 * Organization query service definition
 *
 * @generated from service core.v1.OrganizationQueriesService
 */
export const OrganizationQueriesService: GenService<{
  /**
   * @generated from rpc core.v1.OrganizationQueriesService.GetOrganization
   */
  getOrganization: {
    methodKind: "unary";
    input: typeof GetOrganizationRequestSchema;
    output: typeof GetOrganizationResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationQueriesService.GetOrganizationByName
   */
  getOrganizationByName: {
    methodKind: "unary";
    input: typeof GetOrganizationByNameRequestSchema;
    output: typeof GetOrganizationByNameResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationQueriesService.GetOrganizationByDomain
   */
  getOrganizationByDomain: {
    methodKind: "unary";
    input: typeof GetOrganizationByDomainRequestSchema;
    output: typeof GetOrganizationByDomainResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationQueriesService.GetOrganizationByIdpIDAndUser
   */
  getOrganizationByIdpIDAndUser: {
    methodKind: "unary";
    input: typeof GetOrganizationByIdpIDAndUserRequestSchema;
    output: typeof GetOrganizationByIdpIDAndUserResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationQueriesService.GetOrganizations
   */
  getOrganizations: {
    methodKind: "unary";
    input: typeof GetOrganizationsRequestSchema;
    output: typeof GetOrganizationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_organization, 0);

/**
 * Organization command service definition
 *
 * @generated from service core.v1.OrganizationCommandsService
 */
export const OrganizationCommandsService: GenService<{
  /**
   * @generated from rpc core.v1.OrganizationCommandsService.CreateOrganization
   */
  createOrganization: {
    methodKind: "unary";
    input: typeof CreateOrganizationRequestSchema;
    output: typeof CreateOrganizationResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationCommandsService.UpdateOrganization
   */
  updateOrganization: {
    methodKind: "unary";
    input: typeof UpdateOrganizationRequestSchema;
    output: typeof UpdateOrganizationResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationCommandsService.DeleteOrganization
   */
  deleteOrganization: {
    methodKind: "unary";
    input: typeof DeleteOrganizationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationCommandsService.ResetOrganization
   */
  resetOrganization: {
    methodKind: "unary";
    input: typeof ResetOrganizationRequestSchema;
    output: typeof ResetOrganizationResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationCommandsService.GrantOrganizationEntitlement
   */
  grantOrganizationEntitlement: {
    methodKind: "unary";
    input: typeof GrantOrganizationEntitlementRequestSchema;
    output: typeof GrantOrganizationEntitlementResponseSchema;
  },
  /**
   * @generated from rpc core.v1.OrganizationCommandsService.RevokeOrganizationEntitlement
   */
  revokeOrganizationEntitlement: {
    methodKind: "unary";
    input: typeof RevokeOrganizationEntitlementRequestSchema;
    output: typeof RevokeOrganizationEntitlementResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_organization, 1);

